import axios from "axios";
import { getToken } from "../../../auth/authService";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + "/admin/grammar",
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = getToken();
  console.log("[AdminGrammar] Bearer token present:", !!token);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    console.warn("[AdminGrammar] No token found, request may fail with 401");
  }
  return config;
});

const handle = (label, promise) =>
  promise
    .then((res) => {
      console.log(`[AdminGrammar] ${label} response:`, res.status, res.data);
      return { status: res.status, data: res.data };
    })
    .catch((err) => {
      console.error(`[AdminGrammar] ${label} failed:`, err.response?.status, err.response?.data);
      return {
        status: err.response?.status || 500,
        message: err.response?.data?.message || "Request failed",
      };
    });

// ===== TOPICS =====
export const fetchGrammarTopics = (params) => {
  console.log("[AdminGrammar] Fetching all topics, params:", params);
  return handle("Fetch topics", api.get("/topic", { params }));
};
export const fetchGrammarTopicById = (id) => {
  console.log("[AdminGrammar] Fetching topic by id:", id);
  return handle("Fetch topic by id", api.get(`/topic/${id}`));
};
export const createGrammarTopic = (data) => {
  console.log("[AdminGrammar] Creating topic:", data);
  return handle("Create topic", api.post("/topic", data));
};
export const updateGrammarTopic = (id, data) => {
  console.log("[AdminGrammar] Updating topic id:", id, "data:", data);
  return handle("Update topic", api.put(`/topic/${id}`, data));
};
export const deleteGrammarTopic = (id) => {
  console.log("[AdminGrammar] Deleting topic id:", id);
  return handle("Delete topic", api.delete(`/topic/${id}`));
};

// ===== SUB-TOPICS =====
export const fetchGrammarSubTopicById = (id) => {
  console.log("[AdminGrammar] Fetching sub-topic by id:", id);
  return handle("Fetch sub-topic by id", api.get(`/sub-topic/${id}`));
};
export const createGrammarSubTopic = (data) => {
  console.log("[AdminGrammar] Creating sub-topic:", data);
  return handle("Create sub-topic", api.post("/sub-topic", data));
};
export const updateGrammarSubTopic = (id, data) => {
  console.log("[AdminGrammar] Updating sub-topic id:", id, "data:", data);
  return handle("Update sub-topic", api.put(`/sub-topic/${id}`, data));
};
export const deleteGrammarSubTopic = (id) => {
  console.log("[AdminGrammar] Deleting sub-topic id:", id);
  return handle("Delete sub-topic", api.delete(`/sub-topic/${id}`));
};
